exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".main--XZ7FK8{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;height:110%;overflow:hidden;background-color:var(--background-color);-webkit-transition:background-color .5s ease;transition:background-color .5s ease}", ""]);

// Exports
exports.locals = {
	"main": "main--XZ7FK8"
};